export default __webpack_public_path__ + "static/media/LinkedIn.46d6f792.svg";